import { betStatus } from '../enums/BetStatus';
import { FieldBorderStyle, ImageEnums } from '../enums/GameEnums';

export const detectHistoryFieldColors = (thirdStepData) => {
  return thirdStepData.roundData.map((el, index) => {
    if (thirdStepData.status === betStatus.lose) return FieldBorderStyle.lose;
    if (el.includes(ImageEnums.step)) {
      return FieldBorderStyle.win;
    } else {
      return FieldBorderStyle.none;
    }
  });
};